import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';

@Injectable({
    providedIn: 'root',
})
export class AppRedirectService {
    constructor(private router: Router, private route: ActivatedRoute) {}

    redirectToAppStoreOrPlayStore() {
        const appRedirectParam =
            this.route?.snapshot?.queryParamMap?.get('install');

        if (appRedirectParam && appRedirectParam.toLowerCase() === 'true') {
            const userAgent = navigator?.userAgent;
            if (userAgent) {
                if (/android/i.test(userAgent)) {
                    window.location.href =
                        'https://play.google.com/store/apps/details?id=com.octopus.driver.prod';
                } else if (/iPad|iPhone|iPod/.test(userAgent)) {
                    window.location.href =
                        'https://apps.apple.com/us/app/octopus-driver/id6451264425';
                } else {
                    this.router.navigate(['login']);
                }
            } else {
                this.router.navigate(['login']);
            }
        }
    }
}
